import { useEffect, useMemo } from 'react'
import { isEmpty, values, path, sortBy, pipe, reject } from 'ramda'
import { useSelector, shallowEqual } from 'react-redux'

const sortByName = sortBy(path<any>(['name', 'first']))


export default function useRedirectToStudent(
  check: boolean,
  id: string,
  redirect: (id: number) => void
): boolean {
  const data = useSelector(path(['students', 'data']), shallowEqual)
  const currentCamps = path([id, 'camps'], data)

  const onlyWithCamps = useMemo(() => {
    return pipe(
      values<any, any>,
      reject(({ camps }) => isEmpty(camps)),
      sortByName
    )(data)
  }, [data])

  useEffect(() => {
    if (check && isEmpty(currentCamps)) {
      const someWithCamps = onlyWithCamps[0]
      if (someWithCamps) {
        redirect(someWithCamps.id)
      }
    }
  }, [check, onlyWithCamps, currentCamps])

  return !isEmpty(onlyWithCamps)
}
